(() => {
  document.querySelectorAll('.search-category-grid').forEach((grid) => {
    let drag = null;
    let suppressClick = false;

    function finishDrag() {
      if (!drag) return;

      const pointerId = drag.pointerId;
      drag = null;
      grid.classList.remove('is-dragging');
      if (grid.hasPointerCapture(pointerId)) {
        grid.releasePointerCapture(pointerId);
      }
    }

    grid.addEventListener('pointerdown', (event) => {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 ||
          event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
          grid.scrollWidth <= grid.clientWidth) return;

      drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        scrollLeft: grid.scrollLeft,
        moved: false,
      };
    });

    window.addEventListener('pointermove', (event) => {
      if (!drag || event.pointerId !== drag.pointerId) return;
      if (event.buttons === 0) {
        finishDrag();
        return;
      }

      const distance = event.clientX - drag.startX;
      if (!drag.moved) {
        if (Math.abs(distance) < 5) return;
        drag.moved = true;
        suppressClick = true;
        grid.classList.add('is-dragging');
        grid.setPointerCapture(event.pointerId);
      }

      event.preventDefault();
      grid.scrollLeft = drag.scrollLeft - distance;
    }, { passive: false });

    ['pointerup', 'pointercancel'].forEach((eventName) => {
      window.addEventListener(eventName, (event) => {
        if (drag && event.pointerId === drag.pointerId) finishDrag();
      });
    });
    grid.addEventListener('lostpointercapture', finishDrag);
    window.addEventListener('blur', finishDrag);

    grid.addEventListener('dragstart', (event) => event.preventDefault());
    grid.addEventListener('click', (event) => {
      if (!suppressClick || event.detail === 0) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
  });
})();
